import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const CardsPage = lazy(() => import("./pages/CardsPage"));
const CardEditorPage = lazy(() => import("./pages/CardEditorPage"));
const PublicCardPage = lazy(() => import("./pages/PublicCardPage"));

export const qrCardsModule: FrontModule = {
  id: "qr-cards",
  version: "0.1.0",
  permission: "qr-cards.use",
  label: "QR cards",
  icon: "qr",
  description: "Create your digital business card and share it with a custom QR code.",
  routes: [
    { path: "/qr-cards", Component: CardsPage },
    { path: "/qr-cards/all", element: <CardsPage view="all" /> },
    { path: "/qr-cards/new", Component: CardEditorPage },
    { path: "/qr-cards/:cardId", Component: CardEditorPage },
  ],
  // /p/qr-cards/<slug>: the link inside every QR.
  publicRoutes: [{ path: ":slug", Component: PublicCardPage }],
  menu: [
    {
      id: "qr-cards.cards",
      label: "My cards",
      icon: "qr",
      path: "/qr-cards",
      permission: "qr-cards.use",
      description: "Your business cards with a QR code",
    },
    {
      id: "qr-cards.all",
      label: "All cards",
      icon: "users",
      path: "/qr-cards/all",
      permission: "qr-cards.admin",
      description: "Everyone's cards",
    },
  ],
};

export default qrCardsModule;
